import axios from "axios";

export const countService = () => {
    return axios.get(
        'https://my-json-server.typicode.com/typicode/demo/comments'
    );
}